export default "__VITE_ASSET__ByOOvObW__"